import { useMutation as useMutationBase } from '@apollo/client';
import { useQuery as useQueryBase } from '@apollo/client';
/**
 * @function useQuery
 * @since 1.0.0
 */
export function useQuery(query, options) {
    if (options) {
        if ('skip' in options) {
            const skip = options.skip;
            if (options.fetchPolicy == null) {
                options.fetchPolicy = skip ? 'cache-only' : 'cache-first';
                delete options.skip;
            }
        }
    }
    const result = useQueryBase(query, options);
    const data = result.data
        ? options && options.objectType
            ? result.data
            : result.data
        : null;
    const error = result.error || null;
    const ready = result.loading == false;
    const refetch = result.refetch;
    return [data, ready, error, result, refetch];
}
/**
 * @function useMutation
 * @since 1.0.0
 */
export function useMutation(mutation, options) {
    return useMutationBase(mutation, options);
}
